import '~/constants/WindowConstants'; // we need to import this first as all imports get fully resolved before functions are run.
import React from 'react';
import ReactDOM from 'react-dom';
import Ndx from '~/components/Ndx';
import store from '~/store';
import {recentUploadsTabSyncListener} from '~/utils/middleware/recentUploadsTabSync';
import './adapters/newrelic/newrelic';

import 'normalize.css/normalize.css';
import './application.scss';

window.addEventListener('storage', recentUploadsTabSyncListener(store));

ReactDOM.render(<Ndx store={store} />, document.getElementById('root'));
